import ajax from './ajax';

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface SignupData {
    name: string;
    email: string;
    password: string;
    phone?: string;
    role?: string;
    organizationId?: string;
    organizationName?: string;
    organizationDomain?: string;
}

export interface SignupResponse {
    message: string;
    userId: string;
}

export interface UserProfileInfo {
    name?: string;
    phone?: string;
    avatar?: string;
    timezone?: string;
    language?: string;
}

export interface User {
    _id: string;
    email: string;
    name?: string;
    role: string;
    organizationId?: string;
    emailVerified: boolean;
    profile?: UserProfileInfo;
    createdAt: string;
}

export interface AuthResponse {
    token: string;
    user: User;
}

class AuthService {
    async signup(data: SignupData): Promise<SignupResponse> {
        return ajax.post('/api/auth/signup', data);
    }

    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        return ajax.post('/api/auth/login', credentials);
    }

    async verifyEmail(token: string): Promise<{ message: string }> {
        return ajax.post('/api/auth/verify-email', { token });
    }

    async forgotPassword(email: string): Promise<{ message: string }> {
        return ajax.post('/api/auth/forgot-password', { email });
    }

    async resetPassword(token: string, password: string): Promise<{ message: string }> {
        return ajax.post('/api/auth/reset-password', { token, newPassword: password });
    }

    async refreshToken(): Promise<AuthResponse> {
        return ajax.post('/api/auth/refresh');
    }

    async getCurrentUser(): Promise<User> {
        return ajax.get('/api/users/me');
    }

    async updateProfile(data: Partial<User>): Promise<User> {
        return ajax.put('/api/users/me', data);
    }
}

export default new AuthService();
